import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const HEADLINE = "0% INTEREST. NO FEES.";
const SUB = "Spread the cost of your remedial works.";
const BODY = "Pay 40% upfront and spread the balance over three or six monthly instalments.";
const SMALL = "Available on eligible remedial works, subject to assessment and written agreement.";

const Cta = ({ dark, testId }) => (
  <Link
    to="/payment-plans"
    data-testid={testId}
    className={`inline-flex min-h-[48px] shrink-0 items-center justify-center gap-2 rounded-full px-6 text-sm font-semibold transition-transform hover:scale-[1.02] md:min-h-0 md:py-3 ${
      dark ? "bg-white text-pg-primary" : "bg-pg-primary text-white"}`}
  >
    Explore payment plans
    <ArrowRight className="h-4 w-4" />
  </Link>
);

const Zero = ({ dark }) => (
  <p className={`font-display text-2xl font-extrabold leading-none tracking-tight sm:text-3xl ${
    dark ? "text-white" : "text-pg-primary"}`}>
    <span className="whitespace-nowrap">0% INTEREST.</span>{" "}
    <span className="whitespace-nowrap">NO FEES.</span>
  </p>
);

/**
 * One promotion, three shapes: a full-width blue banner, a pale compact card for sidebars and
 * forms, and a single-line note for survey pages where only remedial works qualify.
 */
export const PaymentPlanPromo = ({ variant = "banner", testId = "payment-plan-promo" }) => {
  if (variant === "note") {
    return (
      <div
        data-testid={testId}
        className="rounded-xl border border-pg-primary/25 bg-pg-pale p-5"
      >
        <p className="text-xs font-bold uppercase tracking-[0.16em] text-pg-primary">
          Payment plans for eligible remedial works
        </p>
        <Zero />
        <p className="mt-2 text-sm leading-relaxed text-pg-text">
          {BODY} Survey and assessment fees are not included.
        </p>
        <div className="mt-4">
          <Cta testId={`${testId}-link`} />
        </div>
        <p className="mt-3 text-[13px] leading-snug text-pg-muted sm:text-xs">{SMALL}</p>
      </div>
    );
  }

  if (variant === "card") {
    return (
      <div
        data-testid={testId}
        className="rounded-xl border border-pg-primary/25 bg-pg-pale p-5"
      >
        <Zero />
        <p className="mt-2 text-sm font-semibold text-pg-dark">{SUB}</p>
        <p className="mt-2 text-sm leading-relaxed text-pg-muted">{BODY}</p>
        <div className="mt-4">
          <Cta testId={`${testId}-link`} />
        </div>
        <p className="mt-3 text-[13px] leading-snug text-pg-muted sm:text-xs">{SMALL}</p>
      </div>
    );
  }

  return (
    <div
      data-testid={testId}
      className="overflow-hidden rounded-2xl bg-pg-primary p-6 shadow-sm sm:p-8"
    >
      <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
        <div className="max-w-2xl">
          <p className="font-display text-3xl font-extrabold leading-none tracking-tight text-white sm:text-4xl">
            <span className="whitespace-nowrap">0% INTEREST.</span>{" "}
            <span className="whitespace-nowrap">NO FEES.</span>
          </p>
          <p className="mt-3 text-base font-semibold text-white md:text-lg">{SUB}</p>
          <p className="mt-2 text-sm leading-relaxed text-white/80">{BODY}</p>
        </div>
        <Cta dark testId={`${testId}-link`} />
      </div>
      <p className="mt-5 border-t border-white/20 pt-4 text-[13px] leading-snug text-white/70 sm:text-xs">
        {SMALL}
      </p>
    </div>
  );
};

export default PaymentPlanPromo;
